const {store, AoflElement} = aofljs;
import './sdo';
/**
 * @summary TestimonialsPopup
 * @class TestimonialsPopup
 * @extends {AoflElement}
 */
class TestimonialsPopup extends AoflElement {
  /**
   * Creates an instance of TestimonialsPopup.
   *
   * @memberof TestimonialsPopup
   */
  constructor() {
    super(store);
    let isMobile = store.getState().userSession.isMobile;
    this.addOrientationChangeHandler(isMobile);
    this.unsubscribeStore = store.subscribe(() => this.mapProperties());
    this.mapProperties();
  }

  /**
   *
   * @readonly
   * @static
   * @memberof TestimonialsPopup
   */
  static get is() {
    return 'testimonials-popup';
  }

  /**
   *
   *
   * @param {String} isMobile
   * @memberof TestimonialsPopup
   */
  addOrientationChangeHandler(isMobile) {
    if (isMobile) {
      window.addEventListener('resize', () => {
        if (window.screen.width <= 568) {
          this.hidePopup();
        }
      });
    }
  }

  /**
   *
   *
   * @memberof TestimonialsPopup
   */
  hidePopup() {
    store.commit([
      {
        stateAlias: 'modals',
        mutationId: 'hideModal',
        payload: 'testimonialsPopup'
      }
    ]);
  }

  /**
   * Maps the components properties to store.
   *
   * @memberof TestimonialsPopup
   */
  mapProperties() {
    let groups = {
      ageTwo: '',
      ageThree: '',
      ageFour: '',
      ageFive: '',
      ageSix: '',
      teachers: ''
    };

    let state = store.getState().testimonialsPopup;
    let selectedGroup = state.selectedGroup;
    groups[selectedGroup] = 'show';

    this.groups = groups;
  }

  /**
   * Updates store with newly selected group
   *
   * @param {Object} e event object
   * @memberof TestimonialsPopup
   */
  updateSelectedGroup(e) {
    let selectedGroup = e.target.dataset.group;
    store.commit([
      {
        stateAlias: 'testimonialsPopup',
        mutationId: 'updateSelectedGroup',
        payload: selectedGroup
      }
    ]);
  }

  /**
   *
   *
   * @memberof TestimonialsPopup
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubscribeStore();
  }
}

window.customElements.define(TestimonialsPopup.is, TestimonialsPopup);

export default TestimonialsPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/testimonials-popup/testimonials-popup.js